import React from 'react';
import DOMPurify from 'dompurify';

// Add a hook to make all links open a new window
DOMPurify.addHook('afterSanitizeAttributes', function(node) {
  // set all elements owning target to target=_blank
  if ('target' in node) {
      node.setAttribute('target','_blank');
      // prevent https://www.owasp.org/index.php/Reverse_Tabnabbing
      node.setAttribute('rel', 'noopener noreferrer');
  }
  // set non-HTML/MathML links to xlink:show=new
  if (!node.hasAttribute('target')
      && (node.hasAttribute('xlink:href')
          || node.hasAttribute('href'))) {
      node.setAttribute('xlink:show', 'new');
  }
});

export const SanitizedHtml = (props) => {

            // I don't know why this is in here twice and why it is indented so far here :(
            // I imagine the function at the top isn't doing anything, but I don't know.

            // Add a hook to make all links open a new window
            DOMPurify.addHook('afterSanitizeAttributes', function(node) {
                // set all elements owning target to target=_blank
                if ('target' in node) {
                    node.setAttribute('target','_blank');
                    // prevent https://www.owasp.org/index.php/Reverse_Tabnabbing
                    node.setAttribute('rel', 'noopener noreferrer');
                }
                // set non-HTML/MathML links to xlink:show=new
                if (!node.hasAttribute('target')
                    && (node.hasAttribute('xlink:href')
                        || node.hasAttribute('href'))) {
                    node.setAttribute('xlink:show', 'new');
                }
            });

  const createMarkup = content => {
    if (!content) return {__html: DOMPurify.sanitize('')};
    if (props.keepLineBreaks) {
      content = content.replace("\n", '<br />') 
    }
    return {__html: DOMPurify.sanitize(content)};
  }

  const Tag = props.tag ? props.tag : 'div';

  if (props.content === null) {
    return ''
  }
  
  return ( 
    <Tag className={props.className} dangerouslySetInnerHTML={createMarkup(props.content)} ></Tag>
  )
}